var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wy-logout-page"},[(!_vm.isC1Auth)?_c('div',[_vm._v("\n    Logout...\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }